import FilterOutlineIcon from '@eduzz/houston-icons/FilterOutline';
import Input from '@eduzz/houston-ui/Forms/Input';
import { Grid } from '@material-ui/core';
import React, { memo } from 'react';

export type InputProductSearchType = {
  classes: any;
  onChange: (value: string) => void;
  onKeyPress: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  value: string;
  handleSearchEnter: (v: string) => void;
};

export const InputProductSearch = memo((props: InputProductSearchType) => {
  return (
    <Grid container justifyContent='flex-end'>
      <Grid item xs={12} md={4}>
        <div className={props.classes.search}>
          <Input
            id='search-product-input'
            value={props.value}
            endAdornment={<FilterOutlineIcon />}
            onChange={props.onChange}
            onBlur={props.onKeyPress}
            onKeyPress={props.onKeyPress}
            placeholder='Pesquise pelo título ou ID do produto'
          />
        </div>
      </Grid>
    </Grid>
  );
});
